import BidCountdown from '@components/BidCountdown/BidCountdown'
import BackToItemList from '@components/Details/BackToItemList'
import BidButton from '../../elements/BidButton/BidButton'
import { C } from '@components/MainLayout/reusable/helpers'
import BidSocialIcons from '@components/BidSocialIcons/BidSocialIcons'
import {
  formatEndDate,
  formatPickupDate,
} from '@components/Details/AuctionDetailInfo'
import { useState } from 'react'
import getEasternTimezone from '@utilities/functions/getEasternTimezone'
import BackToFilteredAuctions from '@components/AuctionDetails/Filters/BackToFilteredAuctions'
import { MdInfoOutline } from 'react-icons/md'

const MobileHeader = ({
  title,
  auction,
  showBackButton,
  address,
  city,
  state,
  zip,
  pageNumber,
  utcEndDateTime,
  itemClosed,
  auctionPickupDates,
  setInfoSlideOutOpen,
  isItemPage,
  itemId,
  endTimeText,
}: any) => {
  const [showMobileInfo, setShowMobileInfo] = useState<any>(false)
  return (
    <>
      <div
        className={
          'mt-2 lg:hidden sticky top-16 md:top-32 z-20 p-1 bg-white rounded-lg'
        }
      >
        <div className="flex justify-evenly gap-2">
          {isItemPage ? (
            <BackToItemList
              auctionId={auction.id}
              pageNumber={pageNumber}
              itemId={itemId}
              showBackToSaveSearch={false}
            />
          ) : (
            <BackToFilteredAuctions />
          )}
          <BidButton
            label={
              <span className="flex justify-center items-center gap-1">
                <MdInfoOutline />
                Auction Info
              </span>
            }
            theme="blue-light"
            width="full"
            callBack={() => setShowMobileInfo((prevState: any) => !prevState)}
          />
        </div>
        {showMobileInfo && (
          <div className="relative ">
            <div className="border-4 absolute w-full grid grid-cols-2 md:grid-cols-3 text-xs border-bidfta-gray-border bg-white z-40">
              <div className="px-4 py-3 flex flex-col md:justify-center md:items-center border-r md:border-b border-bidfta-gray-border">
                <div className="flex flex-col justify-center md:w-40">
                  <h4 className="font-bold text-sm leading-tight uppercase mb-1">
                    Location:
                  </h4>
                  <p>{address}</p>
                  <p>
                    {city}, {state} {zip}
                  </p>
                </div>
              </div>
              <div className="px-4 py-3 flex flex-col md:justify-center md:items-center md:border-r md:border-b border-bidfta-gray-border">
                <div className="flex flex-col justify-center md:w-40">
                  <h4 className="font-bold text-sm leading-tight uppercase mb-1">
                    Pick Up Dates:
                  </h4>
                  <h4 className="font-bold text-sm leading-tight uppercase mb-1">
                    (Local Times)
                  </h4>
                  {auctionPickupDates.map((pickupDate: any, i: any) => (
                    <div
                      className={`py-1 border-bidfta-gray-border ${
                        auctionPickupDates.length !== i + 1 ? 'xl:border-b' : ''
                      }`}
                      key={pickupDate.id}
                    >
                      <p className="font-semibold pb-1">
                        {formatPickupDate(pickupDate.pickupStartTime)}
                      </p>
                      <span className="text-10">
                        {pickupDate.pickupStartTimeText} -{' '}
                        {pickupDate.pickupEndTimeText}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="px-4 py-3 flex flex-col md:justify-center md:items-center border-r md:border-r-0 border-t md:border-t-0 border-b border-bidfta-gray-border">
                <div className="flex flex-col justify-center md:w-40">
                  <h4 className="font-bold text-sm leading-tight uppercase mb-1">
                    Auction End Date:
                  </h4>
                  <div className="mb-1">
                    <p>
                      {formatEndDate(
                        getEasternTimezone(new Date(utcEndDateTime))
                      )}
                    </p>
                    <span>{endTimeText} EST</span>
                  </div>
                  <BidCountdown
                    date={utcEndDateTime}
                    hideClock
                    itemClosed={itemClosed}
                  />
                </div>
              </div>
              <div className="w-full px-4 py-3 flex flex-col justify-center border-t border-b md:border-r md:border-b-0 md:border-t-0 border-bidfta-gray-border gap-2">
                {showBackButton && (
                  <BackToItemList
                    auctionId={auction.id}
                    pageNumber={pageNumber}
                    itemId={itemId}
                  />
                )}
                <div className="w-full">
                  <BidButton
                    label="View Auction Info"
                    theme="blue-light"
                    callBack={() =>
                      setInfoSlideOutOpen((prevState: any) => !prevState)
                    }
                    width="full"
                    buttonStyle="hollow"
                  />
                </div>
              </div>
              <div className="px-4 py-7 flex flex-col md:justify-center md:items-center border-r border-bidfta-gray-border">
                <div className="flex flex-col justify-center md:w-40">
                  <h4 className="font-bold text-sm leading-tight uppercase mb-1">
                    Questions?
                  </h4>
                  <a
                    href={C.AUCTION_CONTACT}
                    className="text-bidfta-blue-light underline font-semibold"
                  >
                    Contact Us Here
                  </a>
                </div>
              </div>
              <div className="px-4 py-7 flex flex-col md:justify-center md:items-center">
                <div className="flex flex-col justify-center md:w-40">
                  <span className="mb-2 block">Share Auction:</span>
                  <div className="flex">
                    <BidSocialIcons />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={'bg-white'}>
        <div className="mt-2 border-2 block lg:hidden w-full border-bidfta-gray-border sticky">
          <div className="p-4 md:px-8 items-center">
            <h3 className="font-bold text-xl">{title}</h3>
            <h3 className="text-md">{auction?.auctionNumber}</h3>
          </div>
        </div>
      </div>
    </>
  )
}

export default MobileHeader
